module.exports = __webpack_public_path__ + "img/BG-4.3dfa96b.png";